import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
export const VillaSimilarRoomsInform = t0 => {
  const $ = _c(1);
  const {
    availability
  } = t0;
  if (availability < 2) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-transparent-secondary flex flex-row items-center gap-2 rounded-lg p-4"><div className="size-[24px]"><MaterialIcon name="info" className="text-headline-5" variant="outlined" /></div><span className="text-body-2">این اقامتگاه دارای واحد‌های مشابه است. امکانات و خدمات تمامی این واحدها یکسان بوده و تنها در دکور یا طبقه تفاوت دارند. واحد نهایی بر اساس موجودی پس از رزرو به شما اختصاص می‌یابد.</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
};